import React from 'react';
import { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { applyStyles, minResolution } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import BreadcrumbsLinks from 'constants/breadcrumbs-links';
import labels from 'i18n/ja/common';
import FontStyles from 'constants/font-styles';
import BreadcrumbsArrow1x from 'assets/images/common/@1x/ic_breadcrumbs_arrow.png';
import BreadcrumbsArrow2x from 'assets/images/common/@2x/ic_breadcrumbs_arrow@2x.png';
import BreadcrumbsArrow3x from 'assets/images/common/@3x/ic_breadcrumbs_arrow@3x.png';

const Breadcrumbs = ({ className, currentPath }) =>
  BreadcrumbsLinks[currentPath] && (
    <nav className={className}>
      <ul>
        {BreadcrumbsLinks[currentPath].map((path, index) => {
          return path !== currentPath ?
          <li key={index}>
            <Link to={path}>{labels.breadcrumbsLabels[path]}</Link>
          </li> :
          <li key={index}>{labels.breadcrumbsLabels[path]}</li>
        })}
      </ul>
    </nav>
  );

const commonStyle = css`
  ${FontStyles.text10};

  ul {
    display: flex;
    padding-left: 0;
    list-style: none;
    margin: 0;

    li {
      position: relative;

      a {
        color: inherit;
        text-decoration: none;
      }
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  ul {
    li {
      &:not(:last-child) {
        margin-right: 26px;

        &::after {
          position: absolute;
          width: 10px;
          height: 10px;
          content: ' ';
          background-size: 10px;
          margin: 7px 8px;
          background-image: url('${BreadcrumbsArrow1x}');

          ${minResolution(2)`
            background-image: url('${BreadcrumbsArrow2x}');
          `}
        }
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
ul {
  li {
    &:not(:last-child) {
      margin-right: 18px;

      &::after {
        position: absolute;
        width: 10px;
        height: 10px;
        content: ' ';
        margin: 5px 4px;
        background-image: url('${BreadcrumbsArrow2x}');
        background-position: center;
        background-size: 8px;

        ${minResolution(3)`
          background-image: url('${BreadcrumbsArrow3x}');
          background-size: 10px;
        `}
      }
    }
  }
}
`;

export default applyStyles(Breadcrumbs)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/Breadcrumbs/index.js